import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">电影分类</h2>
          <p className="text-sm text-foreground-600 mt-2">按类型浏览你喜欢的电影</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 bg-background-100 rounded-lg border border-background-200 transition-all duration-300 hover:scale-[1.03] cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-950 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-500 text-center line-clamp-2">{cat.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}